
// maiHomeScreenTipsCon5TipsCon

import firebase from "../firebase"
import generateHtml from "./generate-html"

import iconPlay from "../../../Icons/NV/white/play.png";
import iconPause from "../../../Icons/NV/white/pause.png";
import register from "../register/register";
import spinner from "../spinner";

// maiTipsCommentsInput

class maiTips {

    #tipsToUse = []
    constructor() {

    }

    _showTips() {
        const parentCon = document.getElementById('maiHomeScreenTipsCon5TipsParentCon')
        parentCon.style.display = 'flex'
    }


    async _initTips() {
        // // just for now
        // return
        const con = document.getElementById('maiHomeScreenTipsCon5TipsCon')

        con.innerHTML = ''
        // Just to take the nesasary screen shots, on return
        this.#tipsToUse = []

        const loadedTips = await firebase._getTips('catGeneral')
        console.log(loadedTips);
        // const tips = [...loadedTips].reverse();
        const tips = loadedTips
        console.log(tips);
        tips.forEach(tip => {
            if (!tip.processing && tip.vidRes?.vid720Url) {
                this.#tipsToUse.push(tip)
            }
        })
        console.log(this.#tipsToUse);
        if (this.#tipsToUse.length < 1) return
        this._videoClickEvents()

        this._showTips()


        this.#tipsToUse.forEach((tip, i) => {
            console.log(tip);
            const html = generateHtml._generateTip(tip, i)
            con.insertAdjacentHTML('beforeend', html)
        })
        setTimeout(() => {

            // this._openVideo(this.#tipsToUse[0])
        }, 10000)

    }

    _videoClickEvents() {
        const maiHomeScreenTipsCon5TipsCon = document.getElementById('maiHomeScreenTipsCon5TipsCon')
        maiHomeScreenTipsCon5TipsCon.addEventListener('click', (e) => {
            console.log('This line');
            const isVideo = e.target.closest('.maiHomeScreenTipsCon6')
            if (!isVideo) return
            console.log('This line');

            const videoIndex = isVideo.dataset.index
            if (!videoIndex) return
            console.log('This line');

            // this._openVideo(this.#tipsToUse[Number(videoIndex)])
            this._openVideo(this.#tipsToUse, videoIndex)


        })
    }


    async _sendNewComment(id, comment) {

        try {
            spinner._displaySpinner('Enviando comentario')
            const account = firebase._getLatestCurrentUserData()

            if (!account) {
                register._displayOptions()
                return { status: 'no-account' }
            }

            console.log(id, 'comment1:', comment);

            const result = await firebase._NVCommentOnTips({ tipId: id, comment })
            console.log(result);
            if (result.data.success) {
                return { status: 'success' }
            } else {
                throw new Error(result.data.message)
            }
        } catch (error) {
            alert(error)
            return { status: 'error' }
        } finally {
            spinner._hideSpinner()
        }

    }

    async _deleteTipComment(tipId, commentId) {
        console.log(tipId, commentId);

        try {
            spinner._displaySpinner('Eliminando comentario')

            const result = await firebase._NVDeleteTipComment({ tipId, commentId })
            console.log(result);
            if (result.data.success) {
                return { success: true }
            } else {
                throw new Error(result.data.message)
            }
        } catch (error) {
            alert(error)
            return { success: false }
        } finally {
            spinner._hideSpinner()
        }
    }

    _openVideo(tips, startIndex = 0) {

        const maiTipsReelsCloseButtonMain = document.getElementById("maiTipsReelsClose");

        const self = this;

        const openMaiTipsReels = async () => {

            const player =
                document.getElementById(
                    "maiTipsReelsPlayer"
                );

            const scroll =
                document.getElementById(
                    "maiTipsReelsScroll"
                );

            const template =
                document.getElementById(
                    "maiTipsReelTemplate"
                );

            const closeButton =
                document.getElementById(
                    "maiTipsReelsClose"
                );

            const commentsSheet =
                document.getElementById(
                    "maiTipsCommentsSheet"
                );



            const commentsList =
                document.getElementById(
                    "maiTipsCommentsList"
                );

            const commentsInput =
                document.getElementById(
                    "maiTipsCommentsInput"
                );

            const commentsSend =
                document.getElementById(
                    "maiTipsCommentsSend"
                );

            scroll.innerHTML = "";

            commentsInput.scrollIntoView({
                block: "nearest"
            });

            // =========================
            // BUILD REELS
            // =========================
            tips.forEach((tip, index) => {

                const clone =
                    template.content.cloneNode(true);

                const reel =
                    clone.querySelector(
                        ".maiTipsReel"
                    );

                const video =
                    clone.querySelector(
                        ".maiTipsReelVideo"
                    );

                const controls =
                    clone.querySelector(
                        ".maiTipsReelControls"
                    );

                const title =
                    clone.querySelector(
                        ".maiTipsReelTitle"
                    );

                const desc =
                    clone.querySelector(
                        ".maiTipsReelDescription"
                    );

                const cta =
                    clone.querySelector(
                        ".maiTipsReelCTA"
                    );

                const quality =
                    clone.querySelector(
                        ".maiTipsReelQuality"
                    );

                const seek =
                    clone.querySelector(
                        ".maiTipsReelSeek"
                    );

                const currentTimeEl =
                    clone.querySelector(
                        ".maiTipsReelCurrentTime"
                    );

                const durationEl =
                    clone.querySelector(
                        ".maiTipsReelDuration"
                    );

                const playPause =
                    clone.querySelector(
                        ".maiTipsReelPlayPause"
                    );

                const commentsPreview =
                    clone.querySelector(
                        ".maiTipsReelCommentsPreviewB"
                    );

                const openComments =
                    clone.querySelector(
                        ".maiTipsReelCommentsPreview"
                    );

                const tapLayer =
                    clone.querySelector(
                        ".maiTipsReelTapLayer"
                    );

                // =========================
                // CONTENT
                // =========================
                title.innerText =
                    tip.title || "";

                desc.innerText =
                    tip.context || "";

                // =========================
                // AUTO QUALITY
                // =========================
                const fast =
                    navigator.connection &&
                    navigator.connection.downlink > 5;

                video.src =
                    fast ?
                        tip.vidRes?.vid1080Url :
                        tip.vidRes?.vid720Url;

                video.poster =
                    tip.images?.[0]?.res_1000 ||
                    tip.images?.[0]?.res_500 ||
                    "";

                // =========================
                // CTA
                // =========================
                if (
                    tip.buttonType !== "none" &&
                    tip.buttonLink
                ) {

                    cta.style.display = "flex";

                    cta.innerText =
                        tip.buttonLabel || "Abrir";

                    cta.onclick = () => {

                        window.open(
                            tip.buttonLink,
                            "_blank"
                        );
                    };
                }

                else {

                    cta.style.display = "none";
                }

                // =========================
                // SHOW CONTROLS
                // =========================
                function showControlsTemporarily() {

                    controls.classList.remove(
                        "hidden"
                    );

                    clearTimeout(
                        reel.hideTimeout
                    );

                    reel.hideTimeout =
                        setTimeout(() => {

                            if (
                                !video.paused
                            ) {

                                controls.classList.add(
                                    "hidden"
                                );
                            }

                        }, 2000);
                }

                // =========================
                // TAP LAYER
                // =========================
                tapLayer.onclick = () => {

                    const controlsVisible =
                        !controls.classList.contains(
                            "hidden"
                        );

                    // CONTROLS VISIBLE
                    // → HIDE
                    if (controlsVisible) {

                        controls.classList.add(
                            "hidden"
                        );

                        return;
                    }

                    // CONTROLS HIDDEN
                    controls.classList.remove(
                        "hidden"
                    );

                    // VIDEO PAUSED
                    if (video.paused) {

                        video.play();

                        playPause.classList.add(
                            "playing"
                        );
                    }

                    // VIDEO PLAYING
                    else {

                        video.pause();

                        playPause.classList.remove(
                            "playing"
                        );
                    }

                    showControlsTemporarily();
                };

                // =========================
                // SEEK BAR
                // =========================

                function formatTime(seconds) {

                    if (!seconds) return "0:00";

                    const mins =
                        Math.floor(seconds / 60);

                    const secs =
                        Math.floor(seconds % 60);

                    return `${mins}:${secs < 10 ? "0" : ""
                        }${secs}`;
                }

                video.ontimeupdate = () => {

                    if (!video.duration) return;

                    seek.value =
                        (
                            video.currentTime /
                            video.duration
                        ) * 100;

                    currentTimeEl.innerText =
                        formatTime(
                            video.currentTime
                        );

                    durationEl.innerText =
                        formatTime(
                            video.duration
                        );
                };

                seek.oninput = () => {

                    video.currentTime =
                        (
                            seek.value / 100
                        ) * video.duration;

                    showControlsTemporarily();
                };

                // =========================
                // PLAY BUTTON
                // =========================
                playPause.onclick = () => {

                    if (video.paused) {

                        video.play();

                        playPause.classList.add(
                            "playing"
                        );
                    }

                    else {

                        video.pause();

                        playPause.classList.remove(
                            "playing"
                        );
                    }

                    showControlsTemporarily();
                };

                // =========================
                // REWIND
                // =========================
                clone.querySelector(
                    ".rewind"
                ).onclick = () => {

                    video.currentTime -= 5;

                    showControlsTemporarily();
                };

                // =========================
                // FORWARD
                // =========================
                clone.querySelector(
                    ".forward"
                ).onclick = () => {

                    video.currentTime += 5;

                    showControlsTemporarily();
                };

                // =========================
                // QUALITY SWITCH
                // =========================
                quality.onchange = () => {

                    const current =
                        video.currentTime;

                    if (
                        quality.value === "720"
                    ) {

                        video.src =
                            tip.vidRes?.vid720Url;
                    }

                    else if (
                        quality.value === "1080"
                    ) {

                        video.src =
                            tip.vidRes?.vid1080Url;
                    }

                    else {

                        video.src =
                            fast ?
                                tip.vidRes?.vid1080Url :
                                tip.vidRes?.vid720Url;
                    }

                    video.load();

                    video.onloadedmetadata =
                        () => {

                            video.currentTime =
                                current;

                            video.play();
                        };
                };

                // =========================
                // COMMENTS PREVIEW
                // =========================
                (async () => {

                    try {

                        const comments =
                            await firebase._loadComments(
                                `mercado_mai_tips/videos/tips/${tip.id}/comments`
                            );

                        commentsPreview.innerHTML = "";

                        comments
                            .slice(0, 1)
                            .forEach((comment) => {

                                const div =
                                    document.createElement(
                                        "div"
                                    );

                                div.className =
                                    "maiTipsReelComment";

                                div.innerHTML = `

                            <div class="maiTipsReelCommentText1">
                                ${comment.name || "Usuario"}
                            </div>

                            <div class="maiTipsReelCommentText2">
                                ${comment.comment || ""}
                            </div>

                        `;

                                commentsPreview.appendChild(
                                    div
                                );
                            });

                    } catch (err) {

                        console.error(
                            "Comments preview error:",
                            err
                        );
                    }

                })();

                // =========================
                // OPEN COMMENTS
                // =========================
                openComments.onclick = async () => {

                    try {
                        maiTipsReelsCloseButtonMain.style.display = "none";

                        commentsSheet.classList.add(
                            "open"
                        );

                        commentsList.innerHTML = "";

                        const comments =
                            await firebase._loadComments(
                                `mercado_mai_tips/videos/tips/${tip.id}/comments`
                            );

                        console.log(comments);

                        const account =
                            firebase._getLatestCurrentUserData();

                        comments.forEach((comment) => {

                            const div =
                                document.createElement(
                                    "div"
                                );

                            div.className =
                                "maiTipsCommentsItem";

                            // =========================
                            // CAN DELETE?
                            // =========================
                            const canDelete =
                                account &&
                                account.userId &&
                                comment.uid === account.userId;

                            div.innerHTML = `

                                    <div class="maiTipsCommentsItemTop">

                                        <div class="maiTipsCommentsItemName">
                                            ${comment.name || "Usuario"}
                                        </div>

                                        ${canDelete ? `

                                            <div
                                                class="maiTipsCommentsDelete"
                                                data-comment-id="${comment.id}"
                                            >
                                                Eliminar
                                            </div>

                                        ` : ""}

                                    </div>

                                    <div class="maiTipsCommentsItemText">
                                        ${comment.comment || ""}
                                    </div>

                                `;

                            // =========================
                            // DELETE COMMENT
                            // =========================
                            if (canDelete) {

                                const deleteBtn =
                                    div.querySelector(
                                        ".maiTipsCommentsDelete"
                                    );

                                deleteBtn.onclick =
                                    async () => {

                                        try {

                                            const confirmDelete =
                                                confirm(
                                                    "¿Eliminar comentario?"
                                                );

                                            if (
                                                !confirmDelete
                                            ) return;

                                            const res =
                                                await this._deleteTipComment(
                                                    tip.id,
                                                    comment.id
                                                );

                                            if (
                                                res?.success
                                            ) {

                                                div.remove();
                                            }

                                        } catch (err) {

                                            console.error(
                                                "Delete comment failed:",
                                                err
                                            );
                                        }
                                    };
                            }

                            commentsList.appendChild(
                                div
                            );
                        });

                        // =========================
                        // SEND COMMENT
                        // =========================
                        commentsSend.onclick =
                            async () => {

                                const value =
                                    commentsInput.value.trim();

                                if (!value) return;

                                try {

                                    const res =
                                        await this._sendNewComment(
                                            tip.id,
                                            value
                                        );

                                    if (
                                        res?.status === 'success'
                                    ) {
                                        console.log('Yep Here');

                                        commentsInput.value =
                                            "";

                                        openComments.click();
                                    } else if (res?.status === 'no-account') {
                                        console.log('Yep Here');
                                        commentsSheet.classList.remove("open")
                                        maiTipsReelsCloseButtonMain.style.display = "flex";
                                        commentsInput.blur()

                                    }

                                } catch (err) {

                                    console.error(
                                        "Comment send failed:",
                                        err
                                    );
                                }
                            };

                    } catch (err) {

                        console.error(
                            "Comments sheet error:",
                            err
                        );
                    }
                };

                scroll.appendChild(clone);
            });

            // =========================
            // SHOW PLAYER
            // =========================
            player.style.display = "block";

            requestAnimationFrame(() => {

                scroll.scrollTo({

                    top:
                        window.innerHeight *
                        startIndex,

                    behavior: "auto",
                });
            });

            // =========================
            // AUTOPLAY
            // =========================
            setupReelsAutoplay();

            // =========================
            // CLOSE PLAYER
            // =========================
            closeButton.onclick = () => {

                player.style.display =
                    "none";

                document
                    .querySelectorAll(
                        ".maiTipsReelVideo"
                    )
                    .forEach((video) => {

                        video.pause();

                        video.src = "";
                    });

                commentsSheet.classList.remove(
                    "open"
                );
                maiTipsReelsCloseButtonMain.style.display = "flex";
                commentsInput.blur()
            };
        }

        openMaiTipsReels();

        // =========================
        // COMMENTS CLICK OUTSIDE
        // =========================
        const clickButton =
            document.getElementById(
                "maiTipsCommentsSheetHandle2"
            );

        const commentsSheet =
            document.getElementById(
                "maiTipsCommentsSheet"
            );

        clickButton.onclick = (e) => {
            commentsSheet.classList.remove(
                "open"
            );
            maiTipsReelsCloseButtonMain.style.display = "flex";
            const commentsInput =
                document.getElementById(
                    "maiTipsCommentsInput"
                );
            commentsInput.blur()

        };

        // =========================
        // DRAG COMMENTS SHEET
        // =========================
        const handle =
            document.querySelector(
                ".maiTipsCommentsSheetHandle2"
            );

        let startY = 0;
        let currentY = 0;
        let dragging = false;

        handle.addEventListener(
            "touchstart",
            (e) => {

                // scroll.style.overflow = "hidden";

                dragging = true;

                startY =
                    e.touches[0].clientY;
            }
        );

        window.addEventListener(
            "touchmove",
            (e) => {

                if (!dragging) return;

                // 🚫 BLOCK PAGE/REELS SCROLL
                e.preventDefault();

                currentY =
                    e.touches[0].clientY;

                const diff =
                    currentY - startY;

                if (diff > 0) {

                    commentsSheet.style.transform =
                        `translateY(${diff}px)`;
                }
            },

            // IMPORTANT
            { passive: false }
        );

        window.addEventListener(
            "touchend",
            () => {

                if (!dragging) return;

                dragging = false;
                // scroll.style.overflow = "";

                const diff =
                    currentY - startY;

                // CLOSE
                if (diff > 120) {

                    commentsSheet.classList.remove(
                        "open"
                    );
                    maiTipsReelsCloseButtonMain.style.display = "flex";
                    const commentsInput =
                        document.getElementById(
                            "maiTipsCommentsInput"
                        );
                    commentsInput.blur()

                    commentsSheet.style.transform =
                        "";
                }

                // RESET
                else {

                    commentsSheet.style.transform =
                        "";
                }
            }
        );

        // =========================
        // AUTOPLAY VISIBLE
        // =========================
        function setupReelsAutoplay() {

            const videos =
                document.querySelectorAll(
                    ".maiTipsReelVideo"
                );

            const observer =
                new IntersectionObserver(

                    (entries) => {

                        entries.forEach(
                            (entry) => {

                                const video =
                                    entry.target;

                                const reel =
                                    video.closest(
                                        ".maiTipsReel"
                                    );

                                const controls =
                                    reel.querySelector(
                                        ".maiTipsReelControls"
                                    );

                                const playPause =
                                    reel.querySelector(
                                        ".maiTipsReelPlayPause"
                                    );

                                if (
                                    entry.isIntersecting
                                ) {

                                    video.play();

                                    commentsSheet.classList.remove(
                                        "open"
                                    );
                                    maiTipsReelsCloseButtonMain.style.display = "flex";

                                    const commentsInput =
                                        document.getElementById(
                                            "maiTipsCommentsInput"
                                        );

                                    commentsInput.blur()

                                    playPause.classList.add(
                                        "playing"
                                    );

                                    setTimeout(() => {

                                        if (
                                            !video.paused
                                        ) {

                                            controls.classList.add(
                                                "hidden"
                                            );
                                        }

                                    }, 2000);
                                }

                                else {

                                    video.pause();

                                    playPause.classList.remove(
                                        "playing"
                                    );
                                }
                            }
                        );
                    },

                    {
                        threshold: 0.7,
                    }
                );

            videos.forEach(
                (video) =>
                    observer.observe(video)
            );
        }

        function handleIOSKeyboard() {

            const inputWrap =
                document.querySelector(
                    ".maiTipsCommentsInputWrap"
                );

            if (
                !window.visualViewport
            ) return;

            const viewport =
                window.visualViewport;

            const keyboardHeight =
                window.innerHeight -
                viewport.height -
                viewport.offsetTop;

            // =========================
            // KEYBOARD OPEN
            // =========================
            if (keyboardHeight > 100) {

                inputWrap.style.transform =
                    `translateY(-${keyboardHeight}px)`;
            }

            // =========================
            // KEYBOARD CLOSED
            // =========================
            else {

                inputWrap.style.transform =
                    `translateY(0px)`;
            }
        }

        if (window.visualViewport) {

            visualViewport.addEventListener(
                "resize",
                handleIOSKeyboard
            );

            visualViewport.addEventListener(
                "scroll",
                handleIOSKeyboard
            );
        }

    }



}


export default new maiTips()